<script>
  import { createEventDispatcher } from 'svelte';
  import { default as short } from "short-uuid";
  import QrCode from "svelte-qrcode";
  export let isPublic;
  let loading = false;
  let error = "";
  let link = "";
  const dispatch = createEventDispatcher();

  var pathname = window.location.pathname;
  if (pathname.startsWith("/maps")) {
    const translator = short("23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", {
                consistentLength: false,
            });
    const mapId = translator.fromUUID(pathname.substring(pathname.lastIndexOf("/") + 1));
    let relative = "";
    if (isPublic) {
          relative = "/link/mp/" + mapId;
      } else {
          relative = "/link/m/" + mapId;
      }
    link = window.location.protocol + "//" + window.location.host + relative;
  } else {
    link = window.location.href;
  }
  
  function close() {
		dispatch('message', {
      type: "modal",
      modal: null
		});
  }
</script>

<div class="modal modal-sm active">
    <div class="modal-overlay"></div>
    <div class="modal-container">
        <div class="modal-header">
            <button class="btn btn-clear float-right" on:click={close} aria-label="Close"></button>
            <div class="modal-title h5">Info</div>
        </div>
        <div class="modal-body">
        <label class="form-label" for="help">Help</label><div><a href="https://help.geosync.cloud" target="_blank" style="
                position: absolute;
                top: 32px;
                left: 26px;
                z-index: 2;
            ">https://help.geosync.cloud</a>
                <input class="form-input" type="text" id="help" readonly="" style="
                visibility: hidden;
            "></div>
            <label class="form-label" for="link">Link</label>
            <input class="form-input" bind:value={link} type="text" id="link" readonly>
            {#if link}
              <div style="text-align:center;"><QrCode value={ link } /></div>
            {/if}
        </div>
    </div>
</div>

<style>
    .modal-container .modal-header {
        padding-bottom: 0;
    }
    .modal-container .modal-body {
        padding-top: 0;
    }
</style>